import React, {useState, useEffect} from "react";
import axios from "axios";
import { baseURL, tuyaUrl } from "services/API";
import DummyTable from "components/DummyViews/DummyTable";
import { Grid, Box, Typography } from "@mui/material";
import {  useGetSmartLocks } from "services/hooks/rentals";
import Button from "@mui/material/Button";
import SyncIcon from "@mui/icons-material/Sync";
import {  useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ProgressScale from "components/ProgressScale";
import FormDialog from "components/modal";
import TopSnack from "components/TopSnack";
import { setSmartDevice, setTuyaToken } from "state";
import SmartLocksTable from "components/Tables/SmartLocksTable";
import SmartLocksPopover from "components/PopOvers/SmartLockPopover";
import SmartLockTemporaryPasswordCreateForm from "components/Forms/SmartLockTemporaryPasswordCreateForm";
import { calculateHeaders, encrypt_AES_128, decrypt_AES_128 } from "utilities/tuyaFunctions";
import moment from "moment";
import * as yup from 'yup';
import { dateTimeToUTC } from "utilities/date";


const deviceData = [
  {
    activeTime: 1737358829000,
    bindSources: [
      {
        permission: 4,
        sourceId: "eu1734513227682UmwBo",
        sourceName: "rentbetatuya@gmail.com",
        sourceType: 4,
      },
    ],
    devId: "bf0a695ea454cb95e8j2z4",
    devName: "Smart Lock",
    icon: "smart/icon/ay1567560614437IQM9s/a4f3aa7417b91caf02d84a42cc11c94f.png",
    isOnline: true,
    isVirtual: false,
    originalName: "Smart Lock",
    pid: "n5mqddeegot9jyva",
    productCategory: "jtmspro",
    productName: "ML100",
    uid: "eu1734513227682UmwBo",
  },
];

const SmartLocks = ({propertyDetails}) => {
	const navigate = useNavigate();
	const property_id = useSelector((state) => state.property_id);
  	const tuyaToken = useSelector((state) => state.tuyaToken);
	const [activeUnit, setActiveUnit] = useState("")
	const [modal, setModal] = React.useState("");
	const dispatch =useDispatch()
	const [anchorEl, setAnchorEl] = useState(null);
	const openPopper = Boolean(anchorEl);
	const popperId = openPopper ? "simple-popover" : undefined;
	const [open, setOpen] = React.useState(false);
	const { smartLocksDetails, isLoadingSmartLocksDetails, errorSmartLocksDetails } = useGetSmartLocks(property_id);
	const [loadingPropertyDetails, setLoadingPropertyDetails] = useState(false);
	const [openSnack, setOpenSnack] = React.useState({
		open: false,
		vertical: "top",
		horizontal: "center",
	});
	const [severity, setSeverity] = React.useState("");
	const [message, setMessage] = React.useState("");
	const [errors, setErrors] = React.useState({})
	const [startDate, setStartDate] = React.useState(moment().format('YYYY-MM-DD HH:mm'));
	const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD HH:mm'));
	const [password, setPassword] = React.useState("");
	const [passwordName, setPasswordName] = React.useState("");
	const [ticket, setTicket]=React.useState("");


	const passwordSchema = yup.object().shape({
		passwordName: yup.string().required('Password Name is required'),
		password: yup.string().length(7, 'Password must be 7 digits').required('Password is required'),
		startDate: yup.string().required('Start Date is required'),
		endDate: yup.string().required('End Date is required'),
	})

	const handleChangePassword = (e)=>{
		const {value, name} = e.target
		if (!toString(value).trim()) {
			setErrors((prev) => ({ ...prev, [name]: `This input is required` }));
		} else {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
		setPassword(value);
	};
	const handleChangePasswordName = (e) => {
		const {value, name} = e.target
		if (!toString(value).trim()) {
			setErrors((prev) => ({ ...prev, [name]: `This input is required` }));
		} else {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
		setPasswordName(value);
	};
	const handleChangeStart = (e) => {
		const {value, name} = e.target
		if (!toString(value).trim()) {
			setErrors((prev) => ({ ...prev, [name]: `This input is required` }));
		} else {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
		setStartDate(value);
	};
	const handleChangeEnd = (e) => {
		const {value, name} = e.target
		if (!toString(value).trim()) {
			setErrors((prev) => ({ ...prev, [name]: `This input is required` }));
		} else {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
		setEndDate(value);
	};

	const handleCloseSnack = (event, reason) => {
		if (reason === "clickaway") {
		return;
		}
		setOpenSnack({ ...openSnack, open: false });
	};

	

	const regitserClient = async () => {
		
		const {easy_sign, clientId, t} = calculateHeaders('token', '/v1.0/token?grant_type=1', null, 'GET' ) 

		const myHeaders = new Headers();
		myHeaders.append("client_id", clientId);
		myHeaders.append("sign", easy_sign);
		myHeaders.append("t", t);
		myHeaders.append("sign_method", "HMAC-SHA256");
		myHeaders.append("mode", "cors")
		myHeaders.append("nonce", "");

		const requestOptions = {
			method: "GET",
			headers: myHeaders,
			redirect: "follow"
		};

		fetch(`${tuyaUrl}/v1.0/token?grant_type=1`, requestOptions)
		.then((response) =>{ 
			return response.json()}
		)
		.then((data) => {
			dispatch(setTuyaToken(data));
		})
		.catch ((e)=>console.error(e))
		
	}


	const getTicket = async () => {
		const {easy_sign, clientId, t} = calculateHeaders('business', `/v1.0/devices/${activeUnit.devId}/door-lock/password-ticket`, tuyaToken.access_token, 'POST' ) 

		const myHeaders = new Headers();
		myHeaders.append("client_id", clientId);
		myHeaders.append("sign", easy_sign);
		myHeaders.append("t", t);
		myHeaders.append("sign_method", "HMAC-SHA256");
		myHeaders.append("mode", "cors")
		myHeaders.append("nonce", "");
		myHeaders.append("access_token", tuyaToken.access_token);

		const requestOptions = {
			method: "POST",
			headers: myHeaders,
			redirect: "follow"
		};

		fetch(`${tuyaUrl}/v1.0/devices/${activeUnit.devId}/door-lock/password-ticket`, requestOptions)
		.then((response) =>{ 
			return response.json()}
		)
		.then((data) => {
			setTicket(data.result)
		})
		.catch ((e)=>console.error(e))
	}



	const handleSubmitNewPassword = async () => {

		try {
			await passwordSchema.validate({passwordName, password, startDate, endDate}, {abortEarly:false});
		} catch (error) {
			const newError = {}
			error.inner.forEach(err => {
				newError[err.path]=err.message
			})
			setErrors(newError)
			return
		}

		const decryptedTemporaryKey = decrypt_AES_128(ticket.ticket_key);
    	const encryptedPassword = encrypt_AES_128(password, decryptedTemporaryKey);

		const {easy_sign, clientId, t } = calculateHeaders('business', `/v1.0/devices/${activeUnit.devId}/door-lock/temp-password`, tuyaToken.access_token, 'POST', JSON.stringify({
				name: passwordName,
				password: encryptedPassword,
				effective_time: (dateTimeToUTC(startDate)/1000),
				invalid_time: (dateTimeToUTC(endDate)/1000),
				password_type: "ticket",
				ticket_id: ticket.ticket_id,
				type:0,
				phone:"" ,
				time_zone: 'Africa/Kampala',
			}
		) ) 

		const myHeaders = new Headers();
		myHeaders.append("client_id", clientId);
		myHeaders.append("sign", easy_sign);
		myHeaders.append("t", t);
		myHeaders.append("sign_method", "HMAC-SHA256");
		myHeaders.append("nonce", "");
		myHeaders.append("mode", "cors")
		myHeaders.append("stringToSign", "");
		myHeaders.append("access_token", tuyaToken.access_token);
		myHeaders.append("Content-Type", 'application/json');


		const requestOptions = {
			method: "POST",
			headers: myHeaders,
			body: JSON.stringify({
				name: passwordName,
				password: encryptedPassword,
				effective_time: (dateTimeToUTC(startDate)/1000),
				invalid_time: (dateTimeToUTC(endDate)/1000),
				password_type: "ticket",
				ticket_id: ticket.ticket_id,
				type:0,
				phone:"" ,
				time_zone: 'Africa/Kampala',
			}),
			redirect: "follow"
		};

		fetch(`${tuyaUrl}/v1.0/devices/${activeUnit.devId}/door-lock/temp-password`, requestOptions)
		.then((response) =>{ 
			return response.json()}
		)
		.then((data) => {
			if (data.success) {
				setOpenSnack({ ...openSnack, open: true });
				setSeverity("success");
				setMessage("Password Created Successfully");
				handleClose()
			} else {
				setOpenSnack({ ...openSnack, open: true });
				setSeverity("error");
				setMessage("Password Creation Failed. Please sync data and try again");
			}
		})
		.catch ((e)=>console.error(e))
	};

	const handleNavigate = (device) => {
		regitserClient()
		dispatch(setSmartDevice(device));
		navigate("/smartLock");
	}

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClickPopOver = (event, row) => {
		setAnchorEl(event.currentTarget);
		setActiveUnit(row);
	};

	const handleClosePopOver = () => {
		setAnchorEl(null);
	};

	const handleModalView = (modalView) => {
		setModal(modalView);
	};

	const handleClose = () => {
		setPassword("");
		setPasswordName("");
		setStartDate(moment().format('YYYY-MM-DD HH:mm'));
		setEndDate(moment().format('YYYY-MM-DD HH:mm'));
		setErrors({});
		setModal("");
	};

	return (
		<Box m="20px">
			<Grid container spacing={2}>
				<Grid item xs={12} spacing={2}>
					{isLoadingSmartLocksDetails && <ProgressScale />}
					<Grid container>
						<Grid item xs={12}>
							<Grid xs={12}>
								<Typography variant="h4" fontWeight={"bold"}>Smart Locks on Property {propertyDetails.rental_name}</Typography>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs={12}  md={8} sx={{ margin:"5px", display: { sm: "flex" }, justifyContent: "end", alignItems: "center" }}>
									<Button className="add-button" variant="contained" onClick={()=> regitserClient()} endIcon={<SyncIcon />}>
										Sync Lock Data
									</Button>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12} spacing={2}>
							<Grid item xs={12} sx={{ marginTop: 3 }}>
								{isLoadingSmartLocksDetails ? 
									<DummyTable /> : 
									<SmartLocksTable rows={deviceData} isLoadingSmartLocksDetails={isLoadingSmartLocksDetails} handleClickPopOver={handleClickPopOver}
									id={popperId}/>
								}
							</Grid>
						</Grid>

						<SmartLocksPopover
							popperId={popperId}
							openPopper={openPopper}
							anchorEl={anchorEl}
							handleClosePopOver={handleClosePopOver}
							handleClickOpen={handleClickOpen}
							handleNavigate={handleNavigate}
							activeUnit={activeUnit}
							handleModalView={handleModalView}
							getTicket={getTicket}
						/>
					</Grid>
				</Grid>
			</Grid>
			{modal === "viewLogs" ? (
				<FormDialog
					title="Device Info"
					// enableActions={deleteButton}
					open={open}
					content={
						<Box>
							Device Logs
						</Box>
					}
					handleClose={handleClose}
					buttonText="Delete Unit"
				/>
			) : modal === "tempPassword" ? (
				<FormDialog
					title="Create Temporary Password"
					enableActions={true}
					open={open}
					content={
						<SmartLockTemporaryPasswordCreateForm 
							password={password}
							passwordName={passwordName}
							startDate={startDate}
							endDate={endDate}		
							handleChangeEnd={handleChangeEnd}
							handleChangePassword={handleChangePassword}
							handleChangePasswordName={handleChangePasswordName}
							handleChangeStart={handleChangeStart}	
							errors={errors}
						/>
					}
					handleSubmit={handleSubmitNewPassword}
					handleClose={handleClose}
					buttonText="Create Password"
				/>
			) : modal === "unlockRemote" ? (
				<FormDialog
					title="Unlock Remotely"
					open={open}
					content={
						<Box>
							<Typography color="red">Cannot use this feature currenlty</Typography>
						</Box>
					}
					handleClose={handleClose}
				/>
			) :  null}
			<TopSnack
				vertical={openSnack.vertical}
				horizontal={openSnack.horizontal}
				open={openSnack.open}
				handleCloseSnack={handleCloseSnack}
				message={message}
				severity={severity}
			/>
		</Box>
	);
};

export default SmartLocks;
